module.exports = __webpack_public_path__ + "static/media/backStrength.bfa7d0ca.png";